import { icons } from '../../assets/extensionIcons';
import apiUrl from '../../assets/apiUrl';
import TextViewer, {
  supportedFormats as TextViewerFormats,
} from './TextViewer';
import file from '../../common/file';
import { useContext, useEffect, useRef, useState } from 'react';
import { FileSystemContext } from '../FileSystem';
import styles from './Viewer.module.scss';

interface Props {
  file: file;
  onEnd: () => void;
}

const Viewer: React.FC<Props> = ({ file, onEnd }) => {
  const [fileUrl, setFileUrl] = useState('');
  const { getSignedUrl } = useContext(FileSystemContext).useFilesMethods();
  useEffect(() => {
    window.Protonfile.FileViewer.emit('open', file, viewerRef.current);
    (async () => {
      const url = await getSignedUrl(
        `${apiUrl}/file?file_uid=${file.file_uid}`
      );
      setFileUrl(url);
    })();
  }, [file, getSignedUrl]);
  const viewerRef = useRef<any>();
  return (
    <div ref={viewerRef} className={styles.Viewer}>
      {icons['fas fa-file-image'].includes(file.extension) && (
        <img src={fileUrl} alt={file.location}></img>
      )}
      {icons['fas fa-file-video'].includes(file.extension) && (
        <video controls={true} src={fileUrl} />
      )}
      {icons['fas fa-file-audio'].includes(file.extension) && (
        <audio controls>
          <source src={fileUrl} />
        </audio>
      )}
      {TextViewerFormats.includes(file.extension) && (
        <TextViewer
          fileUrl={fileUrl}
          fileName={file.filename}
          fileUid={file.file_uid}
        />
      )}
    </div>
  );
};

export default Viewer;
